import React from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import Paper from '@material-ui/core/Paper';
import Topplista from "../Inputs/Large/Topplista";
import Bokade from "../Inputs/ExtraLarge/Bokade";
import Status from "../Inputs/ExtraLarge/Status";
import Avslutning from "../Inputs/ExtraLarge/Avslutning";
import Aktiviteter from "../Inputs/Large/Aktiviteter";
import Aktiverade from "../Inputs/ExtraLarge/Aktiverade";
import Säljare from "../Inputs/Large/Säljare";
import CustomScrollbars from 'util/CustomScrollbars';
import DashBoardDatumFilter from '../Inputs/DashBoardDatumFilter'
const ReactGridLayout = WidthProvider(RGL);

// Lägg till/Ta bort "static: true" på paper för göra boxarna flyttbara eller statiska
export default class StaticElementsLayout extends React.PureComponent {

  render() {
    return (
      <ReactGridLayout
        className="layout i-am-centered"
        rowHeight={40}
        style={{  width: "98vw" }}
      >
        
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="1" 
        // data-grid={{ x: 0, y: 0, w: 4, h: 7, static: true }}>
        data-grid={{ x: 0, y: 0, w: 4, h: 6, static: true }}>
          <span className="text"><Topplista circleHeight={100} Afid={this.props.Afid}  Kontor={this.props.Kontor}/></span>
        </Paper>
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="2" 
        // data-grid={{ x: 4, y: 5, w: 1, h: 2, static: true }}>
        data-grid={{ x: 4, y: 0, w: 2, h: 2, static: true }}>
          <span className="text"><Aktiverade fontSizeAv="14px" Afid={this.props.Afid}  Kontor={this.props.Kontor}/></span>
        </Paper>
         <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="3" 
        //  data-grid={{ x: 5, y: 5, w: 1, h: 2, static: true }}>
         data-grid={{ x: 4, y: 2, w: 2, h: 2, static: true }}>
          <span className="text"><Bokade fontSizeAv="14px" Afid={this.props.Afid} Kontor={this.props.Kontor}/></span>
        </Paper>
      
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="5" 
        // data-grid={{ x: 6, y: 5, w: 1, h: 2, static: true }}>
        data-grid={{ x: 4, y: 4, w: 2, h: 2, static: true }}>
          <span className="text"><Avslutning fontSizeAv="14px" Afid={this.props.Afid} Kontor={this.props.Kontor}/></span>
        </Paper>
         
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="4" 
        // data-grid={{ x: 4, y: 0, w: 3, h: 5, static: true }}>
        data-grid={{ x: 6, y: 0, w: 2, h: 6, static: true }}>
          <span className="text"><Status Afid={this.props.Afid} Kontor={this.props.Kontor}/></span>
        </Paper>
        
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="6" 
        // data-grid={{ x: 7, y: 0, w: 5, h: 7, static: true }}>
        data-grid={{ x: 8, y: 0, w: 4, h: 6, static: true }}>
          <span className="text"><Aktiviteter DsHeight={240} Afid={this.props.Afid} Kontor={this.props.Kontor}/></span>
          {/* <span className="text"><Aktiviteter DsHeight={220}/></span> */}
        </Paper>
       {/* */}
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="7" 
        // data-grid={{ x: 0, y: 7, w: 12, h: 9, static: true }}>
        data-grid={{ x: 0, y: 6, w: 12, h: 6, static: true }}>
          <span className="text"><Säljare DSMaxHeight={245} DsfontSize={14} Afid={this.props.Afid} Kontor={this.props.Kontor} /></span>
          {/* <span className="text"><Säljare DSMaxHeight={420} DsfontSize={16}/></span> */}
        </Paper>
        {/**/}
      </ReactGridLayout>
    );
  }
}